module.exports = __webpack_public_path__ + "img/printing.ee1d8a55.png";